export const GET_LEAVE_REQUESTS_QUERY = `
  query GetLeaveRequests($where: leave_requests_bool_exp = {}, $limit: Int, $offset: Int, $order_by: [leave_requests_order_by!] = [{ id: desc }]) {
    leave_requests_aggregate(where: $where) {
      aggregate { count }
    }
    leave_requests(where: $where, order_by: $order_by, limit: $limit, offset: $offset) {
      id
      start_date
      end_date
      leave_type
      leave_request_description
      duration
      status
      user_id
      company_id
      team_id
      group_id
      is_team_manager_approved
      is_group_manager_approved
      approving_manager_id
      approving_manager {
        first_name
        last_name
      }
      reject_reason
      leaveType {
        id
        leave_type_name
      }
      user {
        first_name
        last_name
        user_annual_leave_balance
        total_leaves_used
        company{
        id
        name
        }
        team{
        id
        name
          group{
            id
            name
          }
        }
      }
    }
  }
`;
